import * as React from "react";

import { cn } from "../lib/utils";

type TextareaCompatProps = {
  multiline?: boolean;
  minRows?: number;
  maxRows?: number;
  label?: string;
};

type TextareaProps = React.ComponentProps<"textarea"> & TextareaCompatProps;

function Textarea({
  className,
  multiline: _multiline,
  minRows,
  maxRows: _maxRows,
  label: _label,
  rows,
  ...props
}: TextareaProps) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive border border-accent flex field-sizing-content min-h-16 w-full rounded-lg bg-accent px-3 py-2 transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 text-sm [@media(hover:none)_and_(pointer:coarse)]:text-base",
        className
      )}
      rows={rows ?? minRows}
      {...props}
    />
  );
}

export { Textarea, type TextareaProps };
